import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({

  select: {
    marginTop: '8px',
    marginBottom: '4px'
  },

  datePicker: {
    marginTop: '9px',
    marginBottom: '4px',

    '& > *': {
      width: '100%'
    },

    '& .MuiOutlinedInput-input': {
      padding: '10.5px 14px'
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(14px, 12px) scale(1)'
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)'
    }

  }

}))